import React, {useState} from 'react';
import style from './style.module.scss'; // won't generate a '.d.ts' file until component is included in the app
import {IHandlers, IProps} from './types';
import {
  Button,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  withStyles
} from '@material-ui/core';
import {makeStyles} from "@material-ui/core/styles";
import moment from "moment";
import {IRecurringBookingSubset} from "shared-services/recurring-booking-service/type";
import {renderIf} from "external-services/react-utils-service";
import {bookingStatusType} from "shared-types/bookingStatusTypes";
import RecurringBookingService from 'shared-services/recurring-booking-service';

const NS = 'EditRecurringBooking';

const StyleTableCell = withStyles({
  root: {
    border: "none"
  }
})(TableCell);

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    overflowX: "auto"
  },
  table: {
    marginBottom: 10,
    borderTop: "none !important",
    borderRight: "none !important"
  },
  deleteBooking: {
    textAlign: "right"
  }
}));

export default function EditRecurringBooking({recurringBookingList, originalBookingId, openRecurringBooking, handleCancelRecurringBookings}: IProps & IHandlers) {

  const classes = useStyles();

  const [updatedRecurringBookingList, setRecurringBookingList] = useState<IRecurringBookingSubset[]>(recurringBookingList);
  const [deletedList, setDeletedList] = useState<string[]>([]);
  const checkForFutureDates = (time: string) => {
    const currentDate = moment();
    const bookingDateTime = moment(time);
    return bookingDateTime.isAfter(currentDate);
  }

  const markForDelete = (booking: IRecurringBookingSubset) => {
    booking.deleteRecurringBooking = !booking.deleteRecurringBooking;
    if (deletedList.includes(booking._id)) {
      setDeletedList(deletedList.filter((id) => id !== booking._id));
    } else {
      setDeletedList([booking._id, ...deletedList]);
    }
  }

  const cancelRecurringBooking = async () => {
    const deletedBookings = await RecurringBookingService.cancelRecurringBookings(recurringBookingList.filter(b => b.deleteRecurringBooking).map(b => b._id));
    const validBookings = recurringBookingList.filter(b => !b.deleteRecurringBooking)
    setRecurringBookingList(validBookings);
    handleCancelRecurringBookings(validBookings)
  }

  const hideCancelledBookings = (recurringBooking: IRecurringBookingSubset) => {
    return recurringBooking.status.statusType !== bookingStatusType.cancelled;
  }


  return (
    <div className={classes.root}>
      <Table className={classes.table} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <StyleTableCell align="left">Booking Time</StyleTableCell>
            <StyleTableCell/>
            <StyleTableCell align="left">Cancel</StyleTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {updatedRecurringBookingList.map((recurringBooking, index) => {
            return (
              <React.Fragment key={index}>
              {renderIf(hideCancelledBookings(recurringBooking), () => (
                <TableRow data-testid="recurring-bookings">
                  <StyleTableCell component="th" scope="row">
                    {moment(recurringBooking.time).format('MMMM D, YYYY HH:mm')}
                  </StyleTableCell>
                  <StyleTableCell align="right">
                    <Button disabled={recurringBooking._id === originalBookingId} size="small" variant="contained"
                            color="primary" className={style.btn}
                            onClick={() => openRecurringBooking(recurringBooking)}>
                      Open Booking
                    </Button>
                  </StyleTableCell>
                  <StyleTableCell padding="checkbox">
                    <Checkbox data-testid="cancelBooking-checkbox"
                              defaultChecked={false}
                              disabled={!checkForFutureDates(recurringBooking.time) || recurringBooking._id === originalBookingId}
                              onChange={() => {
                                markForDelete(recurringBooking)
                              }}
                              color="primary"
                              inputProps={{'aria-label': 'select all bookings to be cancelled'}}
                    />
                  </StyleTableCell>
                </TableRow>
              ))}
              </React.Fragment>
            )
          })}
        </TableBody>
      </Table>
      <Typography variant={"body1"} className={classes.deleteBooking}>
        <Button data-testid="cancelBooking-button" size="small" variant="contained" color="primary"
                disabled={deletedList.length === 0}
                className={style.btn}
                onClick={() => cancelRecurringBooking()}>
          Cancel Booking
        </Button>
      </Typography>

    </div>
  )
}

